// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__0h03I","fullScreen":"style_fullScreen__vwtRh","hidden":"style_hidden__obXeK","loaderSmall":"style_loaderSmall__L7oyn"};